module.exports = __webpack_public_path__ + "static/media/app_icon.c84b3dbb.png";